import React, { useMemo } from "react";
import { useTranslate } from "@refinedev/core";
import { DocumentReaderSegment } from "types/";
import { AnalyticsBarChart, type BarDatasetConfig } from "./AnalyticsBarChart";
import { analyticsTheme } from "./analyticsTheme";

const T_PREFIX =
  "media.projects.analytics.dashboard.summaryCards.readerSegments";

export interface DocumentReaderSegmentsChartProps {
  data: DocumentReaderSegment[] | undefined;
  loading: boolean;
}

export const DocumentReaderSegmentsChart: React.FC<
  DocumentReaderSegmentsChartProps
> = ({ data, loading }) => {
  const t = useTranslate();
  const segments = data ?? [];

  const labels = useMemo(() => segments.map((s) => s.segment), [segments]);

  const datasets = useMemo<BarDatasetConfig[]>(
    () => [
      {
        label: t(`${T_PREFIX}.sessionPct`),
        data: segments.map((s) => Math.round(s.session_pct * 100) / 100),
        color: analyticsTheme.datasetEmerald,
      },
    ],
    [segments, t]
  );

  return (
    <AnalyticsBarChart
      title={t(`${T_PREFIX}.title`)}
      labels={labels}
      datasets={datasets}
      loading={loading}
      direction="horizontal"
      height={200}
    />
  );
};
